import React, { useEffect, useRef, useState } from 'react'
import {
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Button,
} from '@mui/material'
import { Formik } from 'formik'
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import SupplierDetailsReport from '../Components/SupplierDetailReportFile'
import xlsx from 'json-as-xlsx';
import BeatLoader from 'react-spinners/BeatLoader';


function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function SupplierReport() {
    const [pageTitle, setPageTitle] = useState('Supplier Details Report');
    const [supplierList, setSupplierList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [loading, setLoading] = useState(true)

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - supplierList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        GetAllSupplierDetails();
    }, [])

    function GetAllSupplierDetails() {
        axios.get('https://serverfourpaws.ccsoftwares.com/Suppliers/getAllActiveSupplierDetails').then((res) => {
            if (res.data.length > 0) {
                setSupplierList(res.data);
                setLoading(false);
            } else {
                setSupplierList([]);
                toast.error("No records to display!");
            }
        })
    }

    async function createFile() {
        var file = await createDataFromExcel(supplierList);
        var settings = {
            sheetName: 'Supplier Detail Report',
            fileName: 'Supplier Detail Report',
            writeOptions: {}
        }
        let tempcsvHeaders = csvHeaders;
        tempcsvHeaders.push({ label: 'Supplier ID', value: 'SupplierID' })
        tempcsvHeaders.push({ label: 'Supplier Name', value: 'SupplierName' })
        tempcsvHeaders.push({ label: 'Email', value: 'Email' })
        tempcsvHeaders.push({ label: 'ContactNo', value: 'ContactNo' })
        tempcsvHeaders.push({ label: 'ProductsSupplied', value: 'ProductsSupplied' })

        let dataA = [
            {
                sheet: 'Supplier Detail Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }//console.log

    async function createDataFromExcel(dataArray) {
        console.log("dataArray:> ", dataArray)
        var result = [];
        if (dataArray != null) {
            dataArray.forEach(x => {
                result.push({
                    SupplierID: x.SupplierID,
                    SupplierName: x.SupplierName,
                    Email: x.Email,
                    ContactNo: x.ContactNo,
                    ProductsSupplied: x.ProductsSupplied
                });
            }
            );
        }
        return result;
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={12} xs={12}>
                    {titleName}
                </Grid>

            </Grid>
        )
    }

    return (
        <>
            <Container maxWidth={false} >
                <Formik
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form >
                            <Box mt={0}>
                                <Card sx={{ padding: '15px' }}>
                                    <CardHeader
                                        title={cardTitle(pageTitle)}
                                    />
                                    <Divider />
                                    <br />
                                    <TableContainer>
                                        <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>SupplierID</TableCell>
                                                    <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }} >Supplier Name</TableCell>
                                                    <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Contact No</TableCell>
                                                    <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Email</TableCell>
                                                    <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Products Supplied</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {loading ? <>
                                                    <TableRow>
                                                        <TableCell colSpan={5} sx={{ position: 'relative', height: '50px', textAlign: 'center' }}>
                                                            <div style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                transform: 'translate(-50%, -50%)',
                                                            }}>
                                                                <BeatLoader color="#28968E" />
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </> : <>
                                                    {(rowsPerPage > 0
                                                        ? supplierList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : supplierList).map((row) => (
                                                            <TableRow key={row._id}>
                                                                <TableCell align='left'>{row.SupplierID}</TableCell>
                                                                <TableCell align='left'>{row.SupplierName}</TableCell>
                                                                <TableCell align='left'>{row.ContactNo}</TableCell>
                                                                <TableCell align='left'>{row.Email}</TableCell>
                                                                <TableCell align='left'>{row.ProductsSupplied}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    {emptyRows > 0 && (
                                                        <TableRow style={{ height: 53 * emptyRows }}>
                                                            <TableCell colSpan={5} />
                                                        </TableRow>
                                                    )}
                                                </>}
                                            </TableBody>
                                            <TableFooter>
                                                <TableRow>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                        colSpan={5}
                                                        count={supplierList.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        slotProps={{
                                                            select: {
                                                                inputProps: {
                                                                    'aria-label': 'rows per page',
                                                                },
                                                                native: true,
                                                            },
                                                        }}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                        ActionsComponent={TablePaginationActions}
                                                    />
                                                </TableRow>
                                            </TableFooter>
                                        </Table>
                                    </TableContainer>
                                    {supplierList.length > 0 ?
                                        <Box display="flex" justifyContent="flex-end" p={2}>
                                            <Button
                                                color="primary"
                                                id="btnRecord"
                                                variant="contained"
                                                style={{ marginRight: '1rem' }}
                                                onClick={createFile}
                                                size="small"
                                            >
                                                EXCEL
                                            </Button>
                                            <div>&nbsp;</div>
                                            <ReactToPrint
                                                documentTitle={'Supplier Details Report'}
                                                trigger={() => (
                                                    <Button
                                                        color="primary"
                                                        type="button"
                                                        variant="contained"
                                                        size='small'
                                                    >
                                                        PDF
                                                    </Button>
                                                )}
                                                content={() => componentRef.current}
                                            />
                                            <div hidden={true}>
                                                <SupplierDetailsReport
                                                    ref={componentRef}
                                                    supplierList={supplierList}
                                                />
                                            </div>
                                        </Box>
                                        : null}
                                </Card>
                            </Box>
                        </form>
                    )}

                </Formik>
            </Container>
        </>
    )
}

export default SupplierReport